import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { USER_USER_UUID } from '../../lib/api-routes'
import { instance } from '../../lib/axiosInstance'

export interface UserState {
  error: string | null
  loading: boolean
  userUuid: string | null
}

const initialState: UserState = {
  error: null,
  loading: false,
  userUuid: null,
}

export const fetchUserUuid = createAsyncThunk(
  'user/uuid',
  async (userUuidReq: { userId: string }) => {
    return instance
      .get<string>(USER_USER_UUID, {
        params: { userId: userUuidReq.userId },
      })
      .then((response) => response.data || null)
      .catch((error) => {
        throw new Error(
          error.response?.data?.message || 'Failed to fetch user UUID'
        )
      })
  }
)

export const userUuidSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserUuid.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUserUuid.fulfilled, (state, action) => {
        state.loading = false
        state.userUuid = action.payload
      })
      .addCase(fetchUserUuid.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Error fetching user UUID'
      })
  },
  initialState,
  name: 'userUuidSlice',
  reducers: {},
})

export const { reducer: userUuidReducer } = userUuidSlice
